<template>
    <div id="paymentInProgressPage">
        <div class="container bg-white p-4 mb-2">
            <div class="lazada-hc-logo"></div>
            <hr class="customDivider my-3" />
            <div class="d-flex justify-content-between">
                <div class="d-flex flex-column mr-5">
                    <span class="font-md font-weight-bold mb-2"
                        >Your payment is in progress</span
                    >
                    <span class="font-xs text-secondary"
                        >Please review and authorize your payment in the Home
                        Credit app.</span
                    >
                </div>
                <img
                    alt=""
                    src="/img/hcpay/payment-in-progress.svg"
                    class="paymentInProgressIcon img-responsive"
                />
            </div>
            <warning-bar class="mt-4 mb-2"
                >This page will automatically update once your payment is
                complete.</warning-bar
            >
        </div>
        <div
            class="container d-flex flex-column justify-content-center bg-white px-0 py-4"
        >
            <lazada-merchant-details />
            <hr class="customDivider my-4" />
            <div class="px-4">
                <lazada-payment-summary class="mx-auto" />
            </div>
            <lazada-cancel-request
                :eventName="'payment_in_progress_click_cancel_go_back'"
                class="mt-5"
                >{{
                    EnumLabels.CANCEL_AND_GOBACK_MERCHANT
                }}</lazada-cancel-request
            >
        </div>
    </div>
</template>
<script>
import { EnumLabels } from "../../enums/CommonString";

export default {
    data() {
        return {
            EnumLabels,
        };
    },
    methods: {
        changeView(view) {
            this.$root.$data.view = view;
        },
        subscribe() {
            // let vm = this;
            // const tid = this.$root.$data.transactionId;
            // this.$socket.connect(tid, () => {
            //     this.$socket.subscribe(response => {
            //         this.$root.$data.paymentOption = response.paymentOption;
            //         this.$root.$data.paymentOptionLabel = response.paymentOption;
            //         if (
            //             response.status in TRANSACTION_STATUS &&
            //             response.status == TRANSACTION_STATUS.CANCELLED &&
            //             response.transactionID ==
            //                 this.$root.$data.referenceNumber
            //         ) {
            //             this.changeView("lazada-user-canceled");
            //         } else if (
            //             response.status in TRANSACTION_STATUS &&
            //             response.status == TRANSACTION_STATUS.SUCCESS &&
            //             response.transactionID ==
            //                 this.$root.$data.referenceNumber
            //         ) {
            //             this.changeView("lazada-transaction-complete");
            //         } else {
            //             this.changeView("transaction-complete");
            //         }
            //     });
            // });

            /**
             * PUSHER CHANGES
             */
            this.$pusher
                .subscribe("HCPAY_TRANSACTION_STATUS")
                .bind(this.$root.$data.transactionId, (response) => {
                    this.$root.$data.paymentOption = response.paymentOption;
                    if (
                        response.status in TRANSACTION_STATUS &&
                        response.status == TRANSACTION_STATUS.CANCELLED &&
                        response.transactionID ==
                            this.$root.$data.referenceNumber
                    ) {
                        this.changeView("lazada-user-canceled");
                    } else if (
                        response.status in TRANSACTION_STATUS &&
                        response.status == TRANSACTION_STATUS.SUCCESS &&
                        response.transactionID ==
                            this.$root.$data.referenceNumber
                    ) {
                        this.changeView("lazada-transaction-complete");
                    } else {
                        this.changeView("transaction-complete");
                    }
                });
                /** END PUSHER CHANGE */
        },
    },
    created() {
        this.subscribe();
        this.$root.$data.previousView = "payment-in-progress";

        let g4Params = {
            userId: this.$root.$data.account.userId,
            cuid: this.$root.$data.account.cuid,
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type: "WT",
            transaction_reference: this.$root.$data.referenceNumber,
        };
        this.$root.triggerG4Event("payment_in_progress_page", g4Params);
    },
};
</script>
<style scoped>
.paymentInProgressIcon {
    height: auto;
    width: 8rem;
}
.lazada-hc-logo {
    /* Layout Properties */
    top: 14px;
    left: 36px;
    width: 100%;
    height: 52px;
    /* UI Properties */
    background: transparent url("/img/lazada/logos_desktop.png") center
        no-repeat padding-box;
    opacity: 1;
}
</style>
